var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .error-1,\n      .error-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n      .error-1 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Essential_Alerts_alert-diamond",
    "data-name": "Interface-Essential / Alerts / alert-diamond"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_818",
    "data-name": "Shape 818",
    className: "error-1",
    d: "M12,16.5a.38.38,0,1,0,0,.75.38.38,0,0,0,0-.75h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_819",
    "data-name": "Shape 819",
    className: "error-2",
    d: "M12,13.5V6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_820",
    "data-name": "Shape 820",
    className: "error-1",
    d: "M1.28,13.28a1.8,1.8,0,0,1,0-2.56l9.44-9.44a1.81,1.81,0,0,1,2.56,0l9.44,9.44a1.8,1.8,0,0,1,0,2.56l-9.44,9.44a1.8,1.8,0,0,1-2.56,0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.de02ef5f14b1b6ea86b7b225e1a847cc.svg";
export { ForwardRef as ReactComponent };